<template>
  <div
    class="related-links"
    data-ui="related-links"
  >
    <h3 class="related-links__title">Related links</h3>
    <CdrList>
      <li
        v-for="{ key, name, uri } in relatedLinks"
        :key="key"
      >
        <CdrLink
          :href="uri"
          class="related-links__link"
          data-ui="related-link"
          modifier="standalone"
          target="_blank"
          @click="handleClick"
        >
          <span>{{ name }}</span>
          <IconExternalLink
            class="related-links__icon"
            aria-hidden="true"
            inherit-color
          />
        </CdrLink>
      </li>
    </CdrList>
  </div>
</template>

<script>
import { CdrLink, CdrList, IconExternalLink } from '@rei/cedar';
import metrics from '../mixins/metrics';

export default {
  name: 'SessionRelatedLinks',
  components: {
    CdrLink,
    CdrList,
    IconExternalLink,
  },
  mixins: [metrics],
  props: {
    relatedLinks: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleClick({ target }) {
      const linkName = `{{ pageName }}_related links_${target.innerText}`;
      this.metricsClick({ linkName });
    },
  },
};
</script>
